module.exports = __webpack_public_path__ + "img/user-2.1f0aea65.svg";